import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

import { BASE_URL, GET_MECHANIC_GAME_REPORT, GET_PATTERN_LIST, SET_PATTERN_MAINTENANCE, M_POST } from '@/utils/api';

@Module({ name: 'mechanic' })
export default class Mechanic extends VuexModule {
  mechanic: any = [];

  dataGame: any = [];

  @Mutation
  mutateMechanic(mechanic: any) {
    this.mechanic = mechanic;
  }

  @Mutation
  mutateGameReport(dataGame: any) {
    this.dataGame = dataGame;
  }

  @Action({ commit: 'mutateMechanic', rawError: true })
  async FetchPatternList() {
    try {
      const { data } = await axios({
        url: BASE_URL + GET_PATTERN_LIST,
        method: M_POST
      });

      assertOk(data, 'Fetch pattern list failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch pattern list failed');
    }
  }

  @Action({ commit: 'mutateMechanic', rawError: true })
  async PatternMaintenance(req: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + SET_PATTERN_MAINTENANCE,
        method: M_POST,
        data: req
      });

      assertOk(data, 'Pattern update failed');
      return data?.status;
    } catch (err: any) {
      throw toError(err, 'Pattern update failed');
    }
  }

  @Action({ commit: 'mutateGameReport', rawError: true })
  async GetMechanicReport(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + GET_MECHANIC_GAME_REPORT,
        method: M_POST,
        data: criteria,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch mechanic report failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch mechanic report failed');
    }
  }
}
